import React, { useEffect, useRef } from 'react';

/*
  App.jsx
  - Left: editor (add/edit specials)
  - Right: live preview (cards with CTA buttons)
  - Uses Ext JS Classic components mounted into a React ref.
  - Cleanly destroys Ext components on unmount.
*/

export default function App() {
  const mountRef = useRef(null);
  const panelRef = useRef(null);
  console.log('App component rendered. mountRef:', mountRef);

  useEffect(() => {
    if (typeof window.Ext === 'undefined') {
      console.error('Ext JS not found. Load Ext JS scripts and CSS in index.html.');
      return;
    }
    const Ext = window.Ext;
    console.log('Ext JS found:', Ext);

    // Sample data: one or two specials to start with
    const specialsStore = Ext.create('Ext.data.Store', {
      fields: [
        { name: 'id', type: 'int' },
        { name: 'year', type: 'string' },
        { name: 'model', type: 'string' },
        { name: 'apr', type: 'string' },
        { name: 'term', type: 'string' },
        { name: 'expires', type: 'string' },
        { name: 'image', type: 'string' },
        { name: 'ctaPrimary', type: 'string' },
        { name: 'ctaSecondary', type: 'string' },
        { name: 'bgColor', type: 'string' }
      ],
      data: [
        { id: 1, year: '2026', model: 'Rogue', apr: '0%', term: 'for 60 months', expires: '03/31/2026', image: 'https://image.dealertower.com/i6OtUrna3Xd2Pd2UnEOpqDDy67u8d-uYqTXU8ecMQUg/rs:fill:1024:0:1/g:no/q:80/aHR0cHM6Ly9jZG4uZGVhbGVydG93ZXIuY29tL2J1bGstcnVsZS1zcGVjaWFsLWltYWdlLzFkMDE2ZmE0LWJlMDUtNDZlNy1iOGFlLTExNTVjNjMzOTRjZS53ZWJw', ctaPrimary: 'Shop Now', ctaSecondary: 'Reserve Now', bgColor: '#111' },
        { id: 2, year: '2025', model: 'Pathfinder', apr: '0%', term: 'for 60 months', expires: '03/31/2026', image: 'https://image.dealertower.com/_bg1GRO-khq3rnjD4Myq9jHD-fzpjDwYCJ1iUrW_JHM/rs:fill:1024:0:1/g:no/q:80/aHR0cHM6Ly9jZG4uZGVhbGVydG93ZXIuY29tL2J1bGstcnVsZS1zcGVjaWFsLWltYWdlL2E4YmE4MzBkLTVmMmYtNDY0Ni05NTIzLTA4Y2UwNGI1OWVlZS53ZWJw', ctaPrimary: 'Shop Now', ctaSecondary: 'Reserve Now', bgColor: '#283593' },
        { id: 3, year: '2024', model: 'Altima', apr: '1.9%', term: 'for 48 months', expires: '04/15/2026', image: 'https://image.dealertower.com/t4r4qnO2BsLV7K7NL22eNwAp9_LZFWVROgTQEAxVcLQ/rs:fill:1024:0:1/g:no/q:80/aHR0cHM6Ly9jZG4uZGVhbGVydG93ZXIuY29tL2J1bGstcnVsZS1zcGVjaWFsLWltYWdlL2RiMDg4ODc1LWQ3ZjktNGQ1NC05Yzc4LWVlZDYwNjM4MGMyYS53ZWJw', ctaPrimary: 'Lease It', ctaSecondary: 'Get Quote', bgColor: '#00695c' },
        { id: 4, year: '2023', model: 'Sentra', apr: '2.9%', term: 'for 36 months', expires: '05/01/2026', image: '', ctaPrimary: 'Shop Now', ctaSecondary: 'Details', bgColor: '#4a148c' },
        { id: 5, year: '2026', model: 'Kicks', apr: '0.9%', term: 'for 36 months', expires: '04/30/2026', image: 'https://image.dealertower.com/i6OtUrna3Xd2Pd2UnEOpqDDy67u8d-uYqTXU8ecMQUg/rs:fill:1024:0:1/g:no/q:80/aHR0cHM6Ly9jZG4uZGVhbGVydG93ZXIuY29tL2J1bGstcnVsZS1zcGVjaWFsLWltYWdlLzFkMDE2ZmE0LWJlMDUtNDZlNy1iOGFlLTExNTVjNjMzOTRjZS53ZWJw', ctaPrimary: 'Reserve', ctaSecondary: 'More Info', bgColor: '#b71c1c' },
        { id: 6, year: '2025', model: 'Murano', apr: '0%', term: 'for 72 months', expires: '06/30/2026', image: 'https://image.dealertower.com/_bg1GRO-khq3rnjD4Myq9jHD-fzpjDwYCJ1iUrW_JHM/rs:fill:1024:0:1/g:no/q:80/aHR0cHM6Ly9jZG4uZGVhbGVydG93ZXIuY29tL2J1bGstcnVsZS1zcGVjaWFsLWltYWdlL2E4YmE4MzBkLTVmMmYtNDY0Ni05NTIzLTA4Y2UwNGI1OWVlZS53ZWJw', ctaPrimary: 'Shop Now', ctaSecondary: 'Call Dealer', bgColor: '#2e7d32' },
        { id: 7, year: '2024', model: 'Maxima', apr: '0.5%', term: 'for 48 months', expires: '05/15/2026', image: 'https://image.dealertower.com/t4r4qnO2BsLV7K7NL22eNwAp9_LZFWVROgTQEAxVcLQ/rs:fill:1024:0:1/g:no/q:80/aHR0cHM6Ly9jZG4uZGVhbGVydG93ZXIuY29tL2J1bGstcnVsZS1zcGVjaWFsLWltYWdlL2RiMDg4ODc1LWQ3ZjktNGQ1NC05Yzc4LWVlZDYwNjM4MGMyYS53ZWJw', ctaPrimary: 'Shop Now', ctaSecondary: 'Reserve', bgColor: '#ff6f00' },
        { id: 8, year: '2022', model: 'Armada', apr: '1.5%', term: 'for 60 months', expires: '07/31/2026', image: '', ctaPrimary: 'Inquire', ctaSecondary: 'Apply Now', bgColor: '#37474f' },
        { id: 9, year: '2026', model: 'Z', apr: '0%', term: 'for 36 months', expires: '05/31/2026', image: 'https://image.dealertower.com/i6OtUrna3Xd2Pd2UnEOpqDDy67u8d-uYqTXU8ecMQUg/rs:fill:1024:0:1/g:no/q:80/aHR0cHM6Ly9jZG4uZGVhbGVydG93ZXIuY29tL2J1bGstcnVsZS1zcGVjaWFsLWltYWdlLzFkMDE2ZmE0LWJlMDUtNDZlNy1iOGFlLTExNTVjNjMzOTRjZS53ZWJw', ctaPrimary: 'Shop Now', ctaSecondary: 'Details', bgColor: '#01579b' },
        { id: 10, year: '2025', model: 'Frontier', apr: '0.99%', term: 'for 48 months', expires: '06/15/2026', image: 'https://image.dealertower.com/_bg1GRO-khq3rnjD4Myq9jHD-fzpjDwYCJ1iUrW_JHM/rs:fill:1024:0:1/g:no/q:80/aHR0cHM6Ly9jZG4uZGVhbGVydG93ZXIuY29tL2J1bGstcnVsZS1zcGVjaWFsLWltYWdlL2E4YmE4MzBkLTVmMmYtNDY0Ni05NTIzLTA4Y2UwNGI1OWVlZS53ZWJw', ctaPrimary: 'Get Quote', ctaSecondary: 'Finance', bgColor: '#4e342e' },
        { id: 11, year: '2024', model: 'Titan', apr: '2.9%', term: 'for 72 months', expires: '08/01/2026', image: 'https://image.dealertower.com/t4r4qnO2BsLV7K7NL22eNwAp9_LZFWVROgTQEAxVcLQ/rs:fill:1024:0:1/g:no/q:80/aHR0cHM6Ly9jZG4uZGVhbGVydG93ZXIuY29tL2J1bGstcnVsZS1zcGVjaWFsLWltYWdlL2RiMDg4ODc1LWQ3ZjktNGQ1NC05Yzc4LWVlZDYwNjM4MGMyYS53ZWJw', ctaPrimary: 'Apply', ctaSecondary: 'Contact', bgColor: '#455a64' },
        { id: 12, year: '2023', model: 'Leaf', apr: '0%', term: 'for 36 months', expires: '09/30/2026', image: '', ctaPrimary: 'Shop', ctaSecondary: 'More', bgColor: '#0b3' }
      ]
    });

    // Editor form to add / edit a selected special
    const editorForm = Ext.create('Ext.form.Panel', {
      title: 'Special Editor',
      bodyPadding: 10,
      defaults: { anchor: '100%', labelWidth: 90 },
      items: [
        { xtype: 'hiddenfield', name: 'id' },
        { xtype: 'textfield', name: 'year', fieldLabel: 'Year' },
        { xtype: 'textfield', name: 'model', fieldLabel: 'Model' },
        { xtype: 'textfield', name: 'apr', fieldLabel: 'APR' },
        { xtype: 'textfield', name: 'term', fieldLabel: 'Term' },
        { xtype: 'textfield', name: 'expires', fieldLabel: 'Expires' },
        { xtype: 'textfield', name: 'image', fieldLabel: 'Image URL' },
        { xtype: 'textfield', name: 'ctaPrimary', fieldLabel: 'Primary CTA' },
        { xtype: 'textfield', name: 'ctaSecondary', fieldLabel: 'Secondary CTA' },
        {
          xtype: 'colorfield',
          name: 'bgColor',
          fieldLabel: 'BG Color',
          value: '#111'
        }
      ],
      buttons: [
        {
          text: 'Save',
          handler: function () {
            const form = editorForm.getForm();
            if (!form.isValid()) return;
            const values = form.getValues();
            const id = values.id ? parseInt(values.id, 10) : null;
            if (id) {
              const rec = specialsStore.getById(id);
              if (rec) rec.set(values);
            } else {
              // assign new id
              const newId = (specialsStore.max('id') || 0) + 1;
              values.id = newId;
              specialsStore.add(values);
              form.reset();
            }
          }
        },
        {
          text: 'Delete',
          handler: function () {
            const id = editorForm.getForm().findField('id').getValue();
            if (!id) return;
            const rec = specialsStore.getById(parseInt(id, 10));
            if (rec) specialsStore.remove(rec);
            editorForm.getForm().reset();
          }
        },
        {
          text: 'New',
          handler: function () {
            editorForm.getForm().reset();
          }
        }
      ]
    });

    // Grid to list specials and select for editing
    const listGrid = Ext.create('Ext.grid.Panel', {
      title: 'Specials List',
      store: specialsStore,
      columns: [
        { text: 'Year', dataIndex: 'year', width: 80 },
        { text: 'Model', dataIndex: 'model', flex: 1 },
        { text: 'APR', dataIndex: 'apr', width: 80 },
        { text: 'Expires', dataIndex: 'expires', width: 120 }
      ],
      height: 220,
      listeners: {
        select: function (grid, record) {
          editorForm.getForm().loadRecord(record);
        }
      },
      tbar: [
        {
          text: 'Duplicate',
          handler: function () {
            const sel = listGrid.getSelection()[0];
            if (!sel) return;
            const copy = Ext.apply({}, sel.getData());
            copy.id = (specialsStore.max('id') || 0) + 1;
            specialsStore.add(copy);
          }
        },
        {
          text: 'Move Up',
          handler: function () {
            const sel = listGrid.getSelection()[0];
            if (!sel) return;
            const idx = specialsStore.indexOf(sel);
            if (idx > 0) specialsStore.removeAt(idx).insert(idx - 1, sel);
          }
        },
        {
          text: 'Move Down',
          handler: function () {
            const sel = listGrid.getSelection()[0];
            if (!sel) return;
            const idx = specialsStore.indexOf(sel);
            if (idx < specialsStore.getCount() - 1) specialsStore.removeAt(idx).insert(idx + 1, sel);
          }
        }
      ]
    });

    // Live preview container: renders cards from store
    const previewPanel = Ext.create('Ext.panel.Panel', {
      title: 'Live Preview',
      layout: {
        type: 'vbox',
        align: 'stretch'
      },
      bodyPadding: 8,
      defaults: { margin: '0 0 8 0' },
      items: [
        {
          xtype: 'dataview',
          store: specialsStore,
          tpl: new Ext.XTemplate(
            '<div style="display:flex;gap:12px;flex-wrap:wrap;">',
              '<tpl for=".">',
                '<div class="special-card" style="width:320px;border-radius:8px;overflow:hidden;color:#fff;">',
                  '<div style="padding:18px;background:{bgColor};min-height:160px;display:flex;flex-direction:column;justify-content:space-between;order:2;">',
                    '<div>',
                      '<div style="font-size:14px;opacity:0.85;">New {year} {model}</div>',
                      '<div style="font-size:28px;font-weight:700;margin-top:6px;">{apr} <span style="font-size:14px;font-weight:400;">{term}</span></div>',
                      '<div style="margin-top:8px;font-size:12px;opacity:0.9;">Expires {expires}</div>',
                    '</div>',
                    '<div style="display:flex;gap:8px;margin-top:12px;">',
                      '<a href="#" class="cta-primary" style="background:#e53935;color:#fff;padding:8px 12px;border-radius:4px;text-decoration:none;">{ctaPrimary}</a>',
                      '<a href="#" class="cta-secondary" style="background:transparent;border:1px solid rgba(255,255,255,0.2);color:#fff;padding:8px 12px;border-radius:4px;text-decoration:none;">{ctaSecondary}</a>',
                    '</div>',
                  '</div>',
                  '<tpl if="image">',
                    '<div style="height:120px;background:#fff;text-align:center;display:flex;align-items:center;justify-content:center;">',
                      '<img src="{image}" style="max-width:100%;max-height:100%;object-fit:contain;" />',
                    '</div>',
                  '<tpl else>',
                    '<div style="height:120px;background:#f4f4f4;display:flex;align-items:center;justify-content:center;color:#666;">No image</div>',
                  '</tpl>',
                '</div>',
              '</tpl>',
            '</div>'
          ),
          itemSelector: '.special-card',
          listeners: {
            itemclick: function (dv, record) {
              // load into editor on click
              editorForm.getForm().loadRecord(record);
            }
          }
        }
      ]
    });

    // Main panel with two columns: editor (left) and preview (right)
    panelRef.current = Ext.create('Ext.panel.Panel', {
      renderTo: mountRef.current,
      listeners: {
        afterrender: function() {
          console.log('Main Ext JS panel rendered to mountRef:', mountRef.current);
        }
      },
      width: '100%',
      height: 720,
      layout: {
        type: 'hbox',
        align: 'stretch'
      },
      bodyPadding: 8,
      items: [
        {
          xtype: 'panel',
          title: 'Builder',
          width: 420,
          layout: {
            type: 'vbox',
            align: 'stretch'
          },
          items: [
            editorForm,
            listGrid,
            {
              xtype: 'button',
              text: 'Export JSON (console)',
              margin: '8 0 0 0',
              handler: function () {
                console.log(JSON.stringify(specialsStore.getRange().map(r => r.getData()), null, 2));
                Ext.Msg.alert('Export', 'JSON printed to console.');
              }
            }
          ]
        },
        {
          xtype: 'container',
          flex: 1,
          layout: 'fit',
          margin: '0 0 0 12',
          items: [previewPanel]
        }
      ]
    });

    // Cleanup on unmount
    return () => {
      if (panelRef.current && !panelRef.current.isDestroyed) {
        console.log('Destroying main Ext JS panel.');
        panelRef.current.destroy();
        panelRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ padding: 12 }}>
      <div ref={mountRef} />
    </div>
  );
}
